import React from "react";

const flexCenter = (): React.CSSProperties => {
  return {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };
};

export default flexCenter;
